import { api } from './api';

export interface AmlConfig {
  enabled: boolean;
  unitPriceUsd: number;
  currency: string;
  network: string;
  treasury: string | null;
  maxQuantity: number;
}

export interface AmlPurchase {
  id: string;
  quantity: number;
  unitPriceUsd: number;
  totalUsd: number;
  paymentTransferId: string;
  createdAt: string;
}

export interface AmlCheck {
  id: string;
  target: string;
  type: string;
  network: string;
  status: string;
  checkStatus: string | null;
  riskLevel: number | null;
  reportUrl: string | null;
  exposure: Record<string, unknown> | null;
  failureReason: string | null;
  createdAt: string;
}

export function fetchAmlConfig(initData: string) {
  return api<AmlConfig>(initData, '/v1/aml/config');
}

export function fetchAmlMe(initData: string) {
  return api<{ credits: number }>(initData, '/v1/aml/me');
}

export function fetchAmlChecks(initData: string) {
  return api<{ checks: AmlCheck[] }>(initData, '/v1/aml/checks');
}

export function fetchAmlCheck(initData: string, id: string) {
  return api<{ check: AmlCheck }>(initData, `/v1/aml/checks/${id}`);
}

export function buyAmlCredits(initData: string, paymentTransferId: string) {
  return api<{ purchase: AmlPurchase; credits: number }>(initData, '/v1/aml/purchases', {
    method: 'POST',
    body: JSON.stringify({ payment_transfer_id: paymentTransferId }),
  });
}

export function createAmlCheck(initData: string, target: string, idempotencyKey: string) {
  return api<{ check: AmlCheck }>(initData, '/v1/aml/checks', {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify({ target }),
  });
}

export function amlErrorMessage(err: unknown, fallback: string): string {
  const raw = err instanceof Error ? err.message : String(err);
  if (raw.includes('NO_CREDITS')) return 'NO_CREDITS';
  if (raw.includes('DISABLED') || raw.includes('AML_MAINTENANCE') || raw.includes('PROVIDER_FUNDS')) {
    return 'DISABLED';
  }
  if (raw.includes('NOT_FOUND')) return 'NOT_FOUND';
  if (raw.includes('TARGET_INVALID')) return 'TARGET_INVALID';
  if (/insufficient/i.test(raw)) return 'INSUFFICIENT';
  return fallback;
}
